<template>
  <aside
    class="fixed z-10 top-0 pb-3 px-6 w-full flex flex-col justify-between h-screen border-r bg-white transition duration-300 md:w-4/12 lg:ml-0 lg:w-[25%] xl:w-[20%] 2xl:w-[15%]"
    :class="{'ml-[-100%]': value, 'ml-0 ': !value}"
  >
    <div>
      <div class="-mx-6 px-6 py-4">
        <NuxtLink to="/" title="home">
          <h5 class="text-2xl text-gray-600 font-medium lg:block" hidden>
            AfriCareer
          </h5>
        </NuxtLink>
      </div>

      <div class="mt-8 text-center">
        <img
          alt=""
          class="w-10 h-10 m-auto rounded-full object-cover lg:w-28 lg:h-28"
          src="https://tailus.io/sources/blocks/stats-cards/preview/images/second_user.webp"
        >
        <h5 class="hidden mt-4 text-xl font-semibold text-gray-600 lg:block">
          {{ username }}
        </h5>
        <span class="hidden text-gray-400 lg:block">{{ appStore.getEmail }}</span>
      </div>

      <ul class="space-y-2 tracking-wide mt-8" data-test="sidebar-menu">
        <li v-for="(link, index ) in links" :key="index">
          <NuxtLink
            :class="isActiveRoute(link[1]) ? 'rounded-xl text-white bg-gradient-to-r from-blue-900 to-indigo-900' :'text-gray-600 group'"
            :to="link[1]"
            class="px-4 py-3 flex items-center space-x-4"
          >
            <span
              :class="isActiveRoute(link[1]) ? '-mr-1 font-medium' :'group-hover:text-gray-700'"
            >{{ link[0] }}</span>
          </NuxtLink>
        </li>
      </ul>
    </div>

    <div
      class="px-6 -mx-6 pt-4 flex justify-between items-center border-t cursor-pointer"
      @click="logout()"
    >
      <button
        class="px-4 py-3 flex items-center space-x-4 rounded-md text-gray-600 group"
      >
        <span class="group-hover:text-gray-700">Logout</span>
      </button>
    </div>
  </aside>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { useAppStore } from '#imports'

const appStore = useAppStore()
const route = useRoute()
const router = useRouter()
const links = ref([['']])

const profileUrl = (): string => {
  if (appStore.getUser.companies) {
    if (appStore.hasCompany) {
      return '/company/' + appStore.getUser.companies[0].slice('/companies/'.length)
    } else {
      return '/company/create'
    }
  }
  return ''
}
const linksCandidate = [
  ['Votre profil', appStore.getUser.candidateProfile ? '/profil/candidate' : '/candidate/create'],
  ['Offres d\'emploi', '/jobs'],
  ['Soumission', '/jobs/subscription']
]

const linksCompany = [
  ['Tableau de bord', '/'],
  ['Ma Compagnie', profileUrl()],
  ['Offres d\'emploi', '/job']
]

const linksAdmin = [
  ['Tableau de bord', '/'],
  ['Candidats', '/candidates'],
  ['Compagnies', '/companies'],
  ['Offres d\'emploi', '/job'],
  ['Librairie', '/library']
]

links.value = linksCandidate

if (appStore.isGrantedCandidate) {
  links.value = linksCandidate
} else if (appStore.isGrantedCompany) {
  links.value = linksCompany
} else if (appStore.isGrantedAdmin) {
  links.value = linksAdmin
}

interface Props {
    username?: string,
    value: Boolean
}

// defineProps<Props>()
withDefaults(defineProps<Props>(), {
  username: ''
})

function isActiveRoute (path: string): boolean {
  if (path !== '/') {
    return route.fullPath.startsWith(path)
  } else {
    return route.fullPath === path
  }
}

const logout = () => {
  appStore.init()
  router.push({ path: '/login' })
}

</script>
